import React, { useState } from "react";
import { FileText, Eye, MessageSquare, User, ChevronLeft } from "lucide-react";
import TwoColumnLayout from "layouts/TwoColumnLayout";
import Button from "components/buttons";
import PageHeader from "components/PageHeader";
import { useTranslation } from "react-i18next";

interface FeedbackComment {
  id: number;
  name: string;
  role: string;
  date: string;
  comment: string;
  avatar?: string;
}

function DirectorLegislativeDraftRequest() {
  const { t } = useTranslation();
  const [remarks, setRemarks] = useState("");
  const [responseText, setResponseText] = useState("");

  const feedbackComments: FeedbackComment[] = [
    {
      id: 1,
      name: "Senay Daniel",
      role: t("Prosecutor") || "Prosecutor",
      date: "June 12, 2024",
      comment:
        "simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
      avatar:
        "https://images.pexels.com/photos/2379004/pexels-photo-2379004.jpeg?auto=compress&cs=tinysrgb&w=150&h=150&fit=crop",
    },
    {
      id: 2,
      name: "Alem Demes",
      role: t("Coordinator") || "Coordinator",
      date: "June 12, 2024",
      comment:
        "simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
    },
    {
      id: 3,
      name: "Senay Daniel",
      role: t("Prosecutor") || "Prosecutor",
      date: "June 12, 2024",
      comment:
        "simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
      avatar:
        "https://images.pexels.com/photos/2379004/pexels-photo-2379004.jpeg?auto=compress&cs=tinysrgb&w=150&h=150&fit=crop",
    },
  ];

  const handleSendFeedback = () => {
    if (responseText.trim()) {
      console.log("Sending feedback:", responseText);
      setResponseText("");
    }
  };

  const handleViewDocument = (docName: string) => {
    console.log(`Viewing ${docName}`);
  };

  const handleRespondBack = () => {
    console.log("Responding back");
  };

  const handleForwardToCoordinator = () => {
    console.log("Forwarding to coordinator");
  };

  return (
    <>
      <div className="flex flex-row items-baseline space-x-2">
        <button
          className="flex bg-gray-200 items-center justify-center w-10 h-6 px-8 transition-colors duration-200"
          onClick={() => window.history.back()}
        >
          <ChevronLeft />
          {t("Back") || "Back"}
        </button>
        <PageHeader title={t("RequestForLegislativeDrafting") || "Request For Legislative Drafting"} />
      </div>
      <div className="flex flex-row w-full gap-6">
        <div className="w-1/2 overflow-auto">
          {/* Header */}
          <div className="bg-white">
            <div className="border-b border-gray-200 px-8 py-6">
              <h1 className="text-2xl font-semibold text-gray-900">
                {t("RequestLegislativeLetterNumber") || "Request Legislative Letter Number"}: 1234512351
              </h1>
            </div>

            {/* Content */}
            <div className="p-8 space-y-8">
              {/* Document Files */}
              <div className="space-y-4">
                <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg border border-gray-200 hover:bg-gray-100 transition-colors">
                  <div className="flex items-center space-x-3">
                    <div className="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center">
                      <FileText className="w-6 h-6 text-red-600" />
                    </div>
                    <div>
                      <p className="font-medium text-gray-900">
                        {t("DraftInstruction") || "Draft Instruction"}
                      </p>
                      <p className="text-sm text-gray-500">2.3MB</p>
                    </div>
                  </div>
                  <button
                    onClick={() => handleViewDocument("Draft Instruction")}
                    className="flex items-center space-x-2 px-4 py-2 text-sm text-[#432101AB] hover:text-gray-900 hover:bg-white rounded-md transition-colors"
                  >
                    <span>{t("View") || "view"}</span>
                  </button>
                </div>

                <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg border border-gray-200 hover:bg-gray-100 transition-colors">
                  <div className="flex items-center space-x-3">
                    <div className="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center">
                      <FileText className="w-6 h-6 text-red-600" />
                    </div>
                    <div>
                      <p className="font-medium text-gray-900">
                        {t("RequestLetter") || "Request Letter"}
                      </p>
                      <p className="text-sm text-gray-500">2.3MB</p>
                    </div>
                  </div>
                  <button
                    onClick={() => handleViewDocument("Request Letter")}
                    className="flex items-center space-x-2 px-4 py-2 text-sm text-[#432101AB] hover:text-gray-900 hover:bg-white rounded-md transition-colors"
                  >
                    <span>{t("View") || "view"}</span>
                  </button>
                </div>
              </div>

              {/* Basic Information */}
              <div className="grid grid-cols-1 w-full">
                <div className="flex justify-between flex-col w-full">
                  <div className="flex flex-row justify-between py-3 border-b border-gray-200">
                    <span className="text-sm font-medium text-[#432101AB]">
                      {t("StakeholderName") || "Stakeholder Name"}
                    </span>
                    <span className="text-sm font-semibold text-gray-900">
                      OAU
                    </span>
                  </div>
                  <div className="flex flex-row justify-between py-2 border-b border-gray-200">
                    <span className="text-sm font-medium text-[#432101AB]">
                      {t("AppliedDate") || "Applied Date"}
                    </span>
                    <span className="text-sm font-semibold text-gray-900">
                      April 12, 2025
                    </span>
                  </div>
                  <div className="flex flex-row justify-between py-2 border-b border-gray-200">
                    <span className="text-sm font-medium text-[#432101AB]">
                      {t("Address") || "Address"}
                    </span>
                    <span className="text-sm font-semibold text-gray-900">
                      Addis Ababa, Mexico
                    </span>
                  </div>
                </div>
              </div>

              {/* Summary */}
              <div className="space-y-3">
                <h3 className="text-lg font-medium text-[#432101AB]">
                  {t("Summary") || "Summary"}
                </h3>
                <p className="text-sm text-gray-600 leading-relaxed">
                  simply dummy text of the printing and typesetting industry.
                  Lorem Ipsum has been the industry's standard dummy text ever
                  since the 1500s, simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy text ever since the 1500s, simply dummy text of
                  the printing and typesetting industry. Lorem Ipsum has been
                  the industry's standard dummy text ever since the 1500s,
                </p>
              </div>
            </div>
          </div>
          {/* Request Details Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 py-6 border-t border-gray-200 bg-white mt-4">
            <div className="space-y-2 pl-6">
              <p className="text-sm font-medium text-gray-600">{t("Date") || "Date"}</p>
              <p className="text-sm font-semibold text-gray-900">
                January 12, 2024
              </p>
            </div>
            <div className="space-y-2">
              <p className="text-sm font-medium text-gray-600">{t("RequestBy") || "Request by"}</p>
              <p className="text-sm font-semibold text-gray-900">
                Stakeholder name
              </p>
            </div>
            <div className="space-y-2">
              <p className="text-sm font-medium text-gray-600">{t("RequestType") || "Request Type"}</p>
              <p className="text-sm font-semibold text-gray-900">
                {t("LegislativeDrafting") || "Legislative Drafting"}
              </p>
            </div>
            <div className="space-y-2">
              <p className="text-sm font-medium text-gray-600">{t("AssignedTo") || "Assigned To"}</p>
              <p className="text-sm font-semibold text-gray-900">{t("Coordinator") || "Coordinator"}</p>
            </div>
          </div>

          {/* Remarks */}
          <div className="space-y-3 mt-4">
            <h3 className="text-lg font-medium text-gray-900">{t("Remark") || "Remark"}</h3>
            <textarea
              value={remarks}
              onChange={(e) => setRemarks(e.target.value)}
              placeholder={t("DetailHere") || "detail here..."}
              className="w-full h-32 px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none text-sm transition-all"
            />
          </div>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 pt-6 border-t border-gray-200">
            <button
              onClick={handleRespondBack}
              className="flex-1 px-6 py-3 bg-gray-200 text-gray-700 font-medium rounded-lg hover:bg-gray-300 transition-colors focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-offset-2"
            >
              {t("RespondBack") || "Respond back"}
            </button>
            <button
              onClick={handleForwardToCoordinator}
              className="flex-1 px-6 py-3 bg-gray-900 text-white font-medium rounded-lg hover:bg-gray-800 transition-colors focus:outline-none focus:ring-2 focus:ring-gray-900 focus:ring-offset-2"
            >
              {t("ForwardToCoordinator") || "Forward To Coordinator"}
            </button>
          </div>
        </div>

        <div className="w-1/2 bg-white min-h-screen rounded-lg shadow-sm border border-gray-200 overflow-scroll">
          {/* Header */}
          <div className="bg-white border-b border-gray-200 pl-2 py-4">
            <div className="flex items-center space-x-3">
              <div className="w-8 h-8 bg-gray-900 rounded-md flex items-center justify-center">
                <MessageSquare className="w-5 h-5 text-white" />
              </div>
              <h1 className="text-2xl font-semibold text-gray-900">
                {t("FeedbackSection") || "Feedback Section"}
              </h1>
            </div>
          </div>

          {/* Feedback Comments */}
          <div className="space-y-2">
            {feedbackComments.map((feedback, index) => (
              <div key={feedback.id} className="space-y-4 bg-[#D0D0D0] p-2">
                {/* User Info */}
                <div className="flex items-center space-x-4">
                  <div className="w-14 h-14 rounded-full overflow-hidden bg-gray-200 flex items-center justify-center">
                    {feedback.avatar ? (
                      <img
                        src={feedback.avatar}
                        alt={feedback.name}
                        className="w-full h-full object-cover"
                      />
                    ) : (
                      <User className="w-7 h-7 text-gray-500" />
                    )}
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-900">
                      {feedback.name}
                    </h3>
                    <p className="text-sm text-gray-600">{feedback.role}</p>
                  </div>
                </div>

                {/* Comment Date */}
                <div className="ml-18">
                  <p className="text-sm font-medium text-red-600 mb-2">
                    {t("CommentedDate") || "Commented Date"}
                  </p>
                  <p className="text-sm font-semibold text-gray-900 mb-4">
                    {feedback.date}
                  </p>

                  {/* Comment Text */}
                  <p className="text-sm text-gray-600 leading-relaxed">
                    {feedback.comment}
                  </p>
                </div>
              </div>
            ))}
          </div>

          {/* Response Section */}
          <div className="pl-2 pb-8">
            <div className="border-t border-gray-200 pt-8">
              <h3 className="text-lg font-medium text-gray-900 mb-4">
                {t("WriteBackResponseHere") || "Write Back Response here"}
              </h3>

              <div className="flex flex-row space-x-2">
                <input
                  value={responseText}
                  onChange={(e) => setResponseText(e.target.value)}
                  placeholder={t("WriteHere") || "write here..."}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none text-sm transition-all placeholder-gray-400"
                />

                <div className="">
                  <Button onClick={handleSendFeedback}>{t("SendFeedback") || "Send Feedback"}</Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default DirectorLegislativeDraftRequest;